"use client"

import { useEffect, useState } from "react"
import { getCurrentUser } from "@/lib/auth"

export function GlobalPresence() {
  const [userId, setUserId] = useState<number | null>(null)

  useEffect(() => {
    if (typeof window === "undefined") return

    const syncUser = () => {
      const user = getCurrentUser()
      setUserId(user?.id ?? null)
    }

    syncUser()

    const onStorage = (event: StorageEvent) => {
      if (event.key === "currentUser") {
        syncUser()
      }
    }

    window.addEventListener("storage", onStorage)
    return () => window.removeEventListener("storage", onStorage)
  }, [])

  useEffect(() => {
    if (!userId) return

    let active = true

    const ping = async () => {
      if (!active) return
      try {
        await fetch("/api/presence/update", {
          method: "PUT",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ userId, isOnline: true }),
        })
      } catch (err) {
        console.error("[v0] Failed to update presence (global):", err)
      }
    }

    ping()
    const interval = window.setInterval(ping, 10000)

    return () => {
      active = false
      window.clearInterval(interval)
    }
  }, [userId])

  return null
}
